import { localePrefix } from "@workspace/routing";
import isExternalHref from "./isExternalHref";

type PatchHrefLocaleProps = {
  href: string | { pathname?: string; [key: string]: unknown };
  language: string;
  defaultLang: string;
};

const patchHrefLocale = ({
  href,
  language,
  defaultLang,
}: PatchHrefLocaleProps) => {
  // The shared rule decides whether a prefix applies; concatenation stays
  // local so a root pathname keeps producing "/pt/", not "/pt".
  const prefix = localePrefix(language, { defaultLang });
  if (href instanceof Object) {
    if (prefix && href.pathname) {
      href.pathname = `${prefix}${href.pathname}`;
    }
    return href;
  }
  if (isExternalHref(href)) {
    return href;
  }
  return prefix ? `${prefix}${href}` : href;
};

export default patchHrefLocale;
